module.exports = __webpack_public_path__ + "static/resource-toggl-plan-blueprint-573eca8ab2d3d80b6ab0f85e69dd87b0.png";